import { initiateLogin, useDispatch } from "@bonanza-social/toolkit/state";
import { useEffect } from "react";
import { Navigate } from "react-router";

function LoginPage() {
  const dispatch = useDispatch();

  useEffect(() => () => {
    dispatch(initiateLogin());
  });

  return <Navigate to="/" replace />;
}

export default LoginPage;
